export const CLEAR_PREVIOUS_REDUCERS = "CLEAR_PREVIOUS_REDUCERS";

export const FETCH_RIDES_MEMBERSHIP = "FETCH_RIDES_MEMBERSHIP";
export const FETCH_RIDES_MEMBERSHIP_SUCCESS = "FETCH_RIDES_MEMBERSHIP_SUCCESS";
export const FETCH_RIDES_MEMBERSHIP_FAILED = "FETCH_RIDES_MEMBERSHIP_FAILED";

export const FETCH_SINGLE_RIDE_MEMBERSHIP = "FETCH_SINGLE_RIDE_MEMBERSHIP";
export const FETCH_SINGLE_RIDE_MEMBERSHIP_SUCCESS =
  "FETCH_SINGLE_RIDE_MEMBERSHIP_SUCCESS";
export const FETCH_SINGLE_RIDE_MEMBERSHIP_FAILED =
  "FETCH_SINGLE_RIDE_MEMBERSHIP_FAILED";

export const MODERATION_OF_RIDE_GALLERY = "MODERATION_OF_RIDE_GALLERY";
export const MODERATION_OF_RIDE_GALLERY_SUCCESS =
  "MODERATION_OF_RIDE_GALLERY_SUCCESS";
export const MODERATION_OF_RIDE_GALLERY_FAILED =
  "MODERATION_OF_RIDE_GALLERY_FAILED";

export const UPDATE_USER_VIN = "UPDATE_USER_VIN";
export const UPDATE_USER_VIN_SUCCESS = "UPDATE_USER_VIN_SUCCESS";
export const UPDATE_USER_VIN_FAILED = "UPDATE_USER_VIN_FAILED";

export const APPROVE_RIDE_MEMBERSHIP = "APPROVE_RIDE_MEMBERSHIP";
export const APPROVE_RIDE_MEMBERSHIP_SUCCESS =
  "APPROVE_RIDE_MEMBERSHIP_SUCCESS";
export const APPROVE_RIDE_MEMBERSHIP_FAILED = "APPROVE_RIDE_MEMBERSHIP_FAILED";

export const FETCH_ALL_RIDES = "FETCH_ALL_RIDES";
export const FETCH_ALL_RIDES_SUCCESS = "FETCH_ALL_RIDES_SUCCESS";
export const FETCH_ALL_RIDES_FAILED = "FETCH_ALL_RIDES_FAILED";

export const FETCH_ALL_REVIEW = "FETCH_ALL_REVIEW";
export const FETCH_ALL_REVIEW_SUCCESS = "FETCH_ALL_REVIEW_SUCCESS";
export const FETCH_ALL_REVIEW_FAILED = "FETCH_ALL_REVIEW_FAILED";

export const FETCH_SINGLE_RIDE = "FETCH_SINGLE_RIDE";
export const FETCH_SINGLE_RIDE_SUCCESS = "FETCH_SINGLE_RIDE_SUCCESS";
export const FETCH_SINGLE_RIDE_FAILED = "FETCH_SINGLE_RIDE_FAILED";

export const FETCH_COUNTRY = "FETCH_COUNTRY";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAILED = "FETCH_COUNTRY_FAILED";

export const FETCH_STATE = "FETCH_STATE";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_STATE_FAILED = "FETCH_STATE_FAILED";

export const FETCH_CITY = "FETCH_CITY";
export const FETCH_CITY_SUCCESS = "FETCH_CITY_SUCCESS";
export const FETCH_CITY_FAILED = "FETCH_CITY_FAILED";

export const CREATE_RIDES = "CREATE_RIDES";
export const CREATE_RIDES_SUCCESS = "CREATE_RIDES_SUCCESS";
export const CREATE_RIDES_FAILED = "CREATE_RIDES_FAILED";

export const UPDATE_RIDES = "UPDATE_RIDES";
export const UPDATE_RIDES_SUCCESS = "UPDATE_RIDES_SUCCESS";
export const UPDATE_RIDES_FAILED = "UPDATE_RIDES_FAILED";

export const DELETE_RIDES = "DELETE_RIDES";
export const DELETE_RIDES_SUCCESS = "DELETE_RIDES_SUCCESS";
export const DELETE_RIDES_FAILED = "DELETE_RIDES_FAILED";

export const FETCH_CONSENT_FORM = "FETCH_CONSENT_FORM";
export const FETCH_CONSENT_FORM_SUCCESS = "FETCH_CONSENT_FORM_SUCCESS";
export const FETCH_CONSENT_FORM_FAILED = "FETCH_CONSENT_FORM_FAILED";

export const FETCH_RIDES_FOR_MODERATION = "FETCH_RIDES_FOR_MODERATION";
export const FETCH_RIDES_FOR_MODERATION_SUCCESS =
  "FETCH_RIDES_FOR_MODERATION_SUCCESS";
export const FETCH_RIDES_FOR_MODERATION_FAILED =
  "FETCH_RIDES_FOR_MODERATION_FAILED";

export const FETCH_REVIEW_FOR_MODERATION = "FETCH_REVIEW_FOR_MODERATION";
export const FETCH_REVIEW_FOR_MODERATION_SUCCESS =
  "FETCH_REVIEW_FOR_MODERATION_SUCCESS";
export const FETCH_REVIEW_FOR_MODERATION_FAILED =
  "FETCH_REVIEW_FOR_MODERATION_FAILED";

export const FETCH_REVIEW_COUNTRY = "FETCH_REVIEW_COUNTRY";
export const FETCH_REVIEW_COUNTRY_SUCCESS = "FETCH_REVIEW_COUNTRY_SUCCESS";
export const FETCH_REVIEW_COUNTRY_FAILED = "FETCH_REVIEW_COUNTRY_FAILED";

export const FETCH_BRANCH = "FETCH_BRANCH";
export const FETCH_BRANCH_SUCCESS = "FETCH_BRANCH_SUCCESS";
export const FETCH_BRANCH_FAILED = "FETCH_BRANCH_FAILED";

export const FETCH_REVIEW_FILTER = "FETCH_REVIEW_FILTER";
export const FETCH_REVIEW_FILTER_SUCCESS = "FETCH_REVIEW_FILTER_SUCCESS";
export const FETCH_REVIEW_FILTER_FAILED = "FETCH_REVIEW_FILTER_FAILED";

export const FETCH_COUNTRY_IMAGE_FOR_MODERATION =
  "FETCH_COUNTRY_IMAGE_FOR_MODERATION";
export const FETCH_COUNTRY_IMAGE_FOR_MODERATION_SUCCESS =
  "FETCH_COUNTRY_IMAGE_FOR_MODERATION_SUCCESS";
export const FETCH_COUNTRY_IMAGE_FOR_MODERATION_FAILED =
  "FETCH_COUNTRY_IMAGE_FOR_MODERATION_FAILED";

export const FETCH_BRANCH_IMAGE_FOR_MODERATION =
  "FETCH_BRANCH_IMAGE_FOR_MODERATION";
export const FETCH_BRANCH_IMAGE_FOR_MODERATION_SUCCESS =
  "FETCH_BRANCH_IMAGE_FOR_MODERATION_SUCCESS";
export const FETCH_BRANCH_IMAGE_FOR_MODERATION_FAILED =
  "FETCH_BRANCH_IMAGE_FOR_MODERATION_FAILED";

export const FETCH_FILTER_IMAGE_FOR_MODERATION =
  "FETCH_FILTER_IMAGE_FOR_MODERATION";
export const FETCH_FILTER_IMAGE_FOR_MODERATION_SUCCESS =
  "FETCH_FILTER_IMAGE_FOR_MODERATION_SUCCESS";
export const FETCH_FILTER_IMAGE_FOR_MODERATION_FAILED =
  "FETCH_FILTER_IMAGE_FOR_MODERATION_FAILED";

export const MODERATION_OF_RIDES = "MODERATION_OF_RIDES";
export const MODERATION_OF_RIDES_SUCCESS = "MODERATION_OF_RIDES_SUCCESS";
export const MODERATION_OF_RIDES_FAILED = "MODERATION_OF_RIDES_FAILED";

export const FETCH_USER_TO_JOIN_RIDE = "FETCH_USER_TO_JOIN_RIDE";
export const FETCH_USER_TO_JOIN_RIDE_SUCCESS =
  "FETCH_USER_TO_JOIN_RIDE_SUCCESS";
export const FETCH_USER_TO_JOIN_RIDE_FAILED = "FETCH_USER_TO_JOIN_RIDE_FAILED";

export const FETCH_ALL_USERS = "FETCH_ALL_USERS";
export const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_FAILED = "FETCH_ALL_USERS_FAILED";

export const MODERATION_FOR_USER_RIDE = "MODERATION_FOR_USER_RIDE";
export const MODERATION_FOR_USER_RIDE_SUCCESS =
  "MODERATION_FOR_USER_RIDE_SUCCESS";
export const MODERATION_FOR_USER_RIDE_FAILED =
  "MODERATION_FOR_USER_RIDE_FAILED";

export const JOIN_NEW_USER = "JOIN_NEW_USER";
export const JOIN_NEW_USER_SUCCESS = "JOIN_NEW_USER_SUCCESS";
export const JOIN_NEW_USER_FAILED = "JOIN_NEW_USER_FAILED";

export const EXPORT_TO_EXCEL = "EXPORT_TO_EXCEL";
export const EXPORT_TO_EXCEL_SUCCESS = "EXPORT_TO_EXCEL_SUCCESS";
export const EXPORT_TO_EXCEL_FAILED = "EXPORT_TO_EXCEL_FAILED";

export const EXPORT_TO_EXCEL_FOR_REVIEW = "EXPORT_TO_EXCEL_FOR_REVIEW";
export const EXPORT_TO_EXCEL_FOR_REVIEW_SUCCESS =
  "EXPORT_TO_EXCEL_FOR_REVIEW_SUCCESS";
export const EXPORT_TO_EXCEL_FOR_REVIEW_FAILED =
  "EXPORT_TO_EXCEL_FOR_REVIEW_FAILED";

export const FETCH_IMAGES_FOR_MODERATION = "FETCH_IMAGES_FOR_MODERATION";
export const FETCH_IMAGES_FOR_MODERATION_SUCCESS =
  "FETCH_IMAGES_FOR_MODERATION_SUCCESS";
export const FETCH_IMAGES_FOR_MODERATION_FAILED =
  "FETCH_IMAGES_FOR_MODERATION_FAILED";

export const MODERATED_IMAGES = "MODERATED_IMAGES";
export const MODERATED_IMAGES_SUCCESS = "MODERATED_IMAGES_SUCCESS";
export const MODERATED_IMAGES_FAILED = "MODERATED_IMAGES_FAILED";

export const UPDATE_RIDE_BY_ADMIN = "UPDATE_RIDE_BY_ADMIN";
export const UPDATE_RIDE_BY_ADMIN_SUCCESS = "UPDATE_RIDE_BY_ADMIN_SUCCESS";
export const UPDATE_RIDE_BY_ADMIN_FAILED = "UPDATE_RIDE_BY_ADMIN_FAILED";

export const ACTIVITY_FOR_REVIEW = "ACTIVITY_FOR_REVIEW";
export const ACTIVITY_FOR_REVIEW_SUCCESS = "ACTIVITY_FOR_REVIEW_SUCCESS";
export const ACTIVITY_FOR_REVIEW_FAILED = "ACTIVITY_FOR_REVIEW_FAILED";

export const ACTIVITY_FOR_GALLERY = "ACTIVITY_FOR_GALLERY";
export const ACTIVITY_FOR_GALLERY_SUCCESS = "ACTIVITY_FOR_GALLERY_SUCCESS";
export const ACTIVITY_FOR_GALLERY_FAILED = "ACTIVITY_FOR_GALLERY_FAILED";
